import { Container } from '@chakra-ui/react'
import React, { ReactNode } from 'react'
import { bgColorApp } from '../../const/color.ts'
import useGameId from '@hooks/useGameId.ts'
import { oldGameIDs } from '@/utils/oldGameIDs.ts'

export default function LayoutFullWidth({ children }: { children: ReactNode }) {
  const gameId = useGameId()
  const isOldGameID = oldGameIDs.includes(gameId)

  return (
    <Container
      padding={isOldGameID ? '7px' : '0'}
      w={'100%'}
      centerContent
      bgColor={bgColorApp}
    >
      {children}
    </Container>
  )
}
